export default __webpack_public_path__ + "static/media/018-mushroom.6ac5fc0f.svg";